var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.txtInfo,"placement":"top","disabled":_vm.isDisabled}},[_c('div',{staticClass:"wordnowrap",class:{ isLink: 'link-text' },on:{"mouseenter":_vm.isShowTooltip,"click":_vm.linkTo}},[_vm._v(" "+_vm._s(_vm.txtInfo)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }